// // 対象要素を取得
// const $root       = $('#newsTab')
// const $containers = $root.find('.container');
// const $panels     = $root.find('.panel');
// const $buttons    = $root.find('.opener');
// // 初期化処理
// $root.attr('rold', 'tablist');
// $containers.each($.proxy(function (index, elem) {
//   const $container = $(elem);
//   const $button    = $container.find('.opener');
//   const $panel     = $container.find('.panel');
//   const panelId = $panel.attr('id');
//   const buttonId = panelId + '_tab';
//   $button.attr({
//     'aria-expanded': 'false',
//     'aria-selected': 'false',
//     'role'         : 'tab',
//     'id'           : buttonId,
//     'aria-controls': panelId
//   });
//   $panel.attr({
//     'aria-hidden'    : 'true',
//     'role'           : 'tabpanel',
//     'id'             : panelId,
//     'aria-labelledby': buttonId
//   });
// }, this));
// // イベントハンドラ
// $buttons.on('click', function (e) {
//   const $button    = $(e.target);
//   const $panel     = $('#' + $button.attr('aria-controls'));
//   const $container = $button.closest('.container');
//   // ボタン全体を初期化し、クリック対象の属性を変更
//   $buttons.attr('aria-selected', 'false');
//   $button.attr('aria-selected', 'true');
//   // ステートに応じてボタンとパネルの属性値を変更
//   if ($button.attr('aria-expanded') === 'false') {
//     // ボタンとパネルの表示状態を初期化
//     $buttons.attr('aria-expanded', 'false');
//     $panels.attr('aria-hidden', 'true');
//     // 個別の状態を変更
//     $button.attr('aria-expanded', 'true');
//     $panel.attr('aria-hidden', 'false');
//   }
//   else {
//     // ボタンとパネルの表示状態を初期化
//     $buttons.attr('aria-expanded', 'false');
//     $panels.attr('aria-hidden', 'true');
//     // 個別の状態を変更
//     $button.attr('aria-expanded', 'false');
//     $panel.attr('aria-hidden', 'true');
//   }
//   e.stopPropagation(); // 親要素へのバブリングを停止
//   e.preventDefault();  // 要素の標準イベントを停止
// });